<template>
  <div />
</template>

<script lang="ts">
export default { name: 'AuthChecker' }
</script>

<script setup lang="ts">
import axios from 'axios'
import { VueCookies } from 'vue-cookies'
import { inject, onBeforeUnmount, onMounted, ref } from 'vue'

import useAccount from '~/composables/useAccount'
import { useUserStore } from '~/store/modules/user'

const $cookies = inject<VueCookies>('$cookies')

const userStore = useUserStore()

const {
  getAccountUrl,
  basicAuthEnabled,
  basicAuthHeaders,
  authPollingInterval,
  cookieDomain,
} = useAccount()

const pollingInterval = ref<number | undefined>(undefined)

onMounted(async (): Promise<void> => {
  await getUser()

  pollAuth()
})

onBeforeUnmount(() => {
  clearPoll()
})

const getUser = async (): Promise<void> => {
  try {
    let config = {
      withCredentials: true,
    }

    if (basicAuthEnabled) {
      config['headers'] = {
        ...basicAuthHeaders,
      }
    }

    const response = await axios.get(getAccountUrl('api/user?include=cart_count'), config)

    userStore.setCartCount(response?.data?.cart_count)

    delete response?.data?.cart_count

    userStore.setUser(response?.data)
  } catch (error) {
    userStore.setUser(null)

    if (error?.response?.status === 401) {
      await getCart()
    }
  }
}

const pollAuth = () => {
  pollingInterval.value = window.setInterval(async (): Promise<void> => {
    await getUser()
  }, authPollingInterval)
}

const clearPoll = () => {
  window.clearInterval(pollingInterval.value)
}

const getCart = async (): Promise<void> => {
  if (!$cookies) {
    return
  }

  const cartId = $cookies.get('cartId')

  if (cartId) {
    try {
      let config = {}

      if (basicAuthEnabled) {
        config['headers'] = {
          ...basicAuthHeaders,
        }
      }

      const response = await axios.get(getAccountUrl(`api/cart/${cartId}`), config)

      userStore.setCartCount(response?.data?.data?.cart_count)
    } catch (error) {
      if (error?.response?.status === 404) {
        $cookies.remove('cartId', '/', cookieDomain)
      }
    }
  }
}
</script>
